import React from "react";
import { Compass } from "lucide-react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader.js";
import EmptyState from "../components/EmptyState.js";

export default function NotFound(): React.ReactElement {
  return (
    <>
      <PageHeader title="找不到頁面" description="可能是連結拼錯或頁面尚未建立" />
      <EmptyState
        icon={Compass}
        title="404"
        description="這條 dashboard 子路徑目前沒有對應頁面。"
        action={
          <Link to="/dashboard" className="btn-primary text-sm">
            返回總覽
          </Link>
        }
      />
    </>
  );
}
